import styled from 'styled-components';

export const LogoText = styled.h1`
  font-family: 'Great Vibes', cursive;
  font-size: 2.5rem;
  margin-top: 0.5rem;
`;

export const FooterText = styled.h2`
  font-family: 'Vazir', cursive;
  font-size: 1.2rem;
  text-align: center;
  margin: 2rem 0 1rem 0;
`;
